/* eslint-disable no-useless-catch */
import { getAllSerial, getOneSerial } from '@/apis/serialAPI'
import errorHandler from '@/utils/errorHandler'

import { FETCH_SERIALS, FETCH_SERIAL_DETAIL, CLEAR_SERIALS, SET_SERIAL_LOADING } from './actions'
import { ISerial } from '@/utils/types/model/serial'

type TSerialState = {
  serials: ISerial[]
  serialDetail: ISerial | null
  totalRecords: number
  isLoaded: boolean
  isLoading: boolean
}

export default {
  state: {
    serials: [],
    serialDetail: null,
    totalRecords: 0,
    isLoaded: false,
    isLoading: false,
  },
  mutations: {
    [FETCH_SERIALS]: (
      state: TSerialState,
      payload: {
        serials: ISerial[]
        totalRecords: number
      }
    ) => {
      state.serials = payload.serials
      state.totalRecords = payload.totalRecords
      state.isLoaded = true
      state.isLoading = false
    },
    [FETCH_SERIAL_DETAIL]: (state: TSerialState, payload: ISerial) => {
      state.serialDetail = payload
    },
    [CLEAR_SERIALS]: (state: TSerialState) => {
      state.serials = []
      state.serialDetail = null
      state.totalRecords = 0
      state.isLoaded = false
      state.isLoading = false
    },
    [SET_SERIAL_LOADING]: (state: TSerialState, loading: boolean) => {
      state.isLoading = loading
    },
  },
  actions: {
    [FETCH_SERIALS]: async (
      { commit }: { commit: Function },
      payload: {
        page?: number
        limit?: number
        filter?: string
        sort?: string
        code?: string
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_SERIAL_LOADING, true)
        const { page = 1, limit = 10, filter = '', sort = '', code = '', sortBy, sortType } = payload
        const response = await getAllSerial(page, limit, filter, sort, code, sortBy, sortType)
        commit(FETCH_SERIALS, {
          serials: response.serials,
          totalRecords: response.totalRecords,
        })
        return response
      } catch (err) {
        commit(SET_SERIAL_LOADING, false)
        errorHandler(err, {}, true)
        throw err
      }
    },
    [FETCH_SERIAL_DETAIL]: async ({ commit }: { commit: Function }, serialId: string) => {
      try {
        commit(SET_SERIAL_LOADING, true)
        const detail = await getOneSerial(serialId)
        commit(FETCH_SERIAL_DETAIL, detail)
        return detail
      } catch (err) {
        errorHandler(err, {}, true)
        throw err
      } finally {
        commit(SET_SERIAL_LOADING, false)
      }
    },
    [CLEAR_SERIALS]: ({ commit }: { commit: Function }) => {
      commit(CLEAR_SERIALS)
    },
  },
  getters: {
    getSerials: (state: TSerialState) => state.serials,
    getSerialDetail: (state: TSerialState) => state.serialDetail,
    getSerialTotalRecords: (state: TSerialState) => state.totalRecords,
    isSerialLoading: (state: TSerialState) => state.isLoading,
    isSerialLoaded: (state: TSerialState) => state.isLoaded,
  },
}
